import React from "react";
import "./style.scss";
import { X } from "lucide-react";

export const CustomModal: React.FC<{
  showModal: boolean;
  setShowModal: Function;
  children: React.ReactNode;
  removeBtn?: boolean;
  title?: string;
  size?: "sm" | "lg";
}> = ({ showModal, setShowModal, children, title, size, removeBtn= true }) => {
  if (!showModal) {
    return <></>;
  } else {
    return (
      <div
        className={"position-fixed  h-100 overflow-y-auto top-0"}
        style={{
          zIndex: 10,
          width: "100vw",
          left: "0"
        }}
      >
        <div
          className={"custom-modal-back"}
          onClick={() => {
            setShowModal(false);
          }}
        ></div>

        <div
          className={`position-absolute p-3 bg-custom-white col-11 rounded-2  ${
            !size
              ? "col-md-8 col-lg-4"
              : size == "sm"
                ? "col-md-6 col-lg-3"
                : "col-md-10 col-lg-7"
          }`}
          style={{
            top: "120px",
            left: "50%",
            transform: "translate(-50%, 0)",
            zIndex: 11
          }}
          onClick={() => {
          }}
        >
          {removeBtn ? <div className="d-flex flex-row justify-content-between">
            <strong>{title}</strong>
            <X
              className="g-cursor-pointer"
              onClick={() => setShowModal(false)}
            />
          </div> : <></>}
          <hr />
          {children}
        </div>
      </div>
    );
  }
};